import { render, staticRenderFns } from "./ModalViewFile.vue?vue&type=template&id=5d8922b0&scoped=true"
import script from "./ModalViewFile.vue?vue&type=script&lang=js"
export * from "./ModalViewFile.vue?vue&type=script&lang=js"
import style0 from "./ModalViewFile.vue?vue&type=style&index=0&id=5d8922b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8922b0",
  null
  
)

export default component.exports